import request from "@/utils/request"
const host = "/api/sso"
const host_mds = "/api/mds"
const host_rbac = "/api/rbac"
const host_linksphere = "/api/linksphere"
const host_actlog = "/api/actlog"

/**
 * 登录
 * @returns {AxiosPromise}
 */
export function login(data) {
  return request({
    url: host + "/sso-login",
    method: "post",
    headers: {
      isToken: false
    },
    data
  })
}
/**
 * 获取验证码
 * @returns {AxiosPromise}
 */
export function getVerify(data) {
  return request({
    url: host + "/verifyCode",
    headers: {
      isToken: false
    },
    method: "get"
  })
}
/**
 * 获取登录人信息
 * @returns {AxiosPromise}
 */
export function getInfo() {
  return request({
    url: host + "/sso-current-user",
    method: "get"
  })
}

/**
 * 登出
 * @returns {AxiosPromise}
 */
export function logout() {
  return request({
    url: host + "/sso-logout",
    method: "post"
  })
}

/**
 * 获取用户权限
 * @returns {AxiosPromise}
 */
export function getMenu() {
  return request({
    // url: host_rbac + "/menu/nav",
    url: host_rbac + "/menu-info/nav",
    method: "get"
  })
}
/**
 * 修改密码
 * @returns {AxiosPromise}
 */
export function resetPsw(data) {
  return request({
    url: host_mds + "/user/updatePassword",
    method: "post",
    data
  })
}
/**
 * 判断是否修改过初始密码
 * @returns {AxiosPromise}
 */
export const getIsFirstLogin = params => {
  return request({
    url: host_mds + "/user/getIsFirstLogin",
    method: "get",
    params
  })
}

/**
 * 收藏菜单
 * @returns {AxiosPromise}
 */
export function userCollectMenu(data) {
  return request({
    url: host_rbac + "/user-collect-menu",
    method: "post",
    data
  })
}

/**
 * 取消收藏菜单
 * @returns {AxiosPromise}
 */
export function userCollectMenuDel(data) {
  return request({
    url: host_rbac + "/user-collect-menu",
    method: "DELETE",
    data
  })
}
/**
 * 获取收藏菜单
 * @returns {AxiosPromise}
 */
export function getUserCollectMenu() {
  return request({
    url: host_rbac + "/user-collect-menu/list",
    method: "get"
  })
}

/**
 * 修改收藏菜单排序
 * @returns {AxiosPromise}
 */
export function collectMenuUpdateSort(data) {
  return request({
    url: host_rbac + "/user-collect-menu/update-sort",
    method: "post",
    data
  })
}

/**
 * 个人资料
 * @returns {AxiosPromise}
 */

export function apiStaffGetStaffInfo(params) {
  return request({
    url: host_mds + "/staff/get-staff-info",
    method: "get",
    params
  })
}

/**
 * 通用设置
 * @returns {AxiosPromise}
 */
export function apiUserGeneralSettingsFind(params) {
  return request({
    url: host_mds + "/userGeneralSettings/find",
    method: "get",
    params
  })
}

/**
 * 更新通用设置
 * @returns {AxiosPromise}
 */
export function apiUserGeneralSettingsUpdateByUserId(data) {
  return request({
    url: host_mds + "/userGeneralSettings/update-by-user-id",
    method: "post",
    data
  })
}

/**
 * 修改头像
 * @returns {AxiosPromise}
 */
export function apiStaffStaffImage(data) {
  return request({
    url: host_mds + "/staff/staff-image",
    method: "put",
    data
  })
}

/**
 * 获取im通讯账号
 * @returns {*}
 * @param data
 */
export const apiGetImInfo = data => {
  return request({
    url: "/api/voyager" + "/account/get-delivery-account",
    method: "post",
    data
  })
}

/**
 * 所有未读系统消息（用户端）
 * @returns {AxiosPromise}
 */
export function apiGetAllDimensionSystemMessage(data) {
  return request({
    url: host_linksphere + "/user/msg/unread-sys-msg",
    method: "post",
    data
  })
}
/**
 * 单条消息已读
 * @returns {AxiosPromise}
 */
export function apiReadSingleMessage(data) {
  return request({
    url: host_linksphere + "/user/msg/read",
    method: "post",
    data
  })
}

// 模拟单条消息触发
export function apiSendTestMessage(data) {
  return request({
    url: host_linksphere + "/sys/msg/notify/notify-test",
    method: "post",
    data
  })
}

/**
 * 获取通知类型
 * @returns {AxiosPromise}
 */
export function apiGetNotifyType() {
  return request({
    url: host_linksphere + "/msg/type/all",
    method: "post"
  })
}

/**
 * 获取用户所有通知列表
 * @returns {AxiosPromise}
 */
export function apiGetNotifyList(data) {
  return request({
    url: host_linksphere + "/user/msg/page-list",
    method: "post",
    data
  })
}

/**
 * 一键已读
 * @returns {AxiosPromise}
 */
export function apiReadAllNotify(data) {
  return request({
    url: host_linksphere + "/user/msg/all-read",
    method: "post",
    data
  })
}

/**
 * 单条消息已读
 * @returns {AxiosPromise}
 */
export function apiReadUserSingleMessage(data) {
  return request({
    url: host_linksphere + "/user/msg/read",
    method: "post",
    data
  })
}

/**
 * 获取当前用户导入导出列表
 * @returns {AxiosPromise}
 */
export function apiExportPage(data) {
  return request({
    url: host_actlog + "/common/import/export/current/page",
    method: "post",
    data
  })
}

/**
 * 获取当前用户正在进行中的任务数量
 * @returns {AxiosPromise}
 */
export function apiGetCurrentTask() {
  return request({
    url: host_actlog + "/common/import/export/current/num",
    method: "get"
  })
}

/**
 * (新)获取当前用户正在进行中的任务数量
 * @returns {AxiosPromise}
 */
export function apiGetCurrentTaskCount() {
  return request({
    url: host_actlog + "/common/import/export/new/current/num",
    method: "get"
  })
}

/**
 * 获取导入导出枚举接口
 * @returns {AxiosPromise}
 */
export function apiGetExportEnumList() {
  return request({
    url: host_actlog + "/common/import/export/enumList",
    method: "get"
  })
}

/**
 * 新增日志
 * @returns {AxiosPromise}
 */
export function apiAddLog(data) {
  return request({
    url: host_actlog + "/common-business-log/save-log",
    method: "post",
    data
  })
}
